export default __webpack_public_path__ + "05f5eb9a4a9d898ce15731f1183ea356.svg";